import '../chart_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.NPSChartView extends Monitoring.Views.Charts.ChartView
  id: 'nps-chart'
  className: 'processing item'
  template: JST['backbone/templates/monitoring/charts/generic_chart']

  events:
    'click #close_chart': 'destroy'
    'click #save_note': 'saveNote'
    'click #delete_note': 'deleteNote'
    'click .insert-note': 'displayNote'

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.nps_field')
    @searchQuery = @options.searchQuery
    @_settings = @options.settings
    @detractorColor = '#c0392b'
    @passiveColor = '#ff9800'
    @promoterColor = '#27ae60'
    @minScore = 0
    @maxScore = 10

  render: ->
    @$el.html @template
      title: @title
    @trigger('masonry')
    @

  afterAppend: ->
    @ajaxCall('/monitoring/api/charts/single_dimension', @getSearchQuery().toJSON(), (response) =>
      scores = @parseData(response.series[0].data)
      @$el.removeClass('processing')
      @$el.find('.chart').append(new Monitoring.Views.Charts.HorizontalBarChartView(data: scores).render().el)
    )

  getSearchQuery: ->
    query = @searchQuery.deepCopy()
    query.set('dimension', 'nps')
    query

  parseData: (data) =>
    scores = @initializeScores()
    _.each(data, (item) =>
      scores[item.code].y = item.y
      scores[item.code].color = @scoreColor(parseInt(item.code))
    )
    scores

  destroy: ->
    super()
    Backbone.trigger('charts:closed:update')

  initializeScores: ->
    scores = []
    for i in [@minScore..@maxScore]
      scores.push {code: i, y: 0}
    scores

  scoreColor: (score) ->
    switch
      when score <= 6 then @detractorColor
      when score in [7, 8] then @passiveColor
      when score in [9, 10] then @promoterColor
